const errorConstants = {
  GENERAL_ERR: 'General error',
  APP_CATCH_ERR: 'App Catch error',
  VALIDATION_FAILS: 'Validation  error',
  ACTION_ERR: 'An error has occurred, please try again!',
  ERR_INVALID_TEMPLATE: 'Invalid template. Please download the latest format',
  ERR_INVALID_FILE_HEADERS: 'These column(s) are missing in your file: ',
  BULK_UPLOAD_FAILS: 'Bulk upload unsuccessful!',
  401: 'Unauthorized',
  400: 'Unauthorized',
  403: "You don't have the necessary permissions to perform this action",
  404: '404 Not Found',
  500: 'Unable to process your request',
  503: 'Unable to process your request',
  504: '504 Timeout',
  OPTIMA_INDENT_CHECK_FAILS: 'Unable to generate indent list',
  OPTIMA_REJECTED_MATERIALS: 'Some materials have not been fitted!',
  OPTIMA_ALREADY_IN_QUEUE: 'Another optima request in progress for this depot!',
  BULK_UPLOAD_MIRO_FAILS: 'Bulk upload unsuccessful!',
  LISTING_FAILS: 'Initial data load problem. Please try again!',
  INDENT_CREATION_FAILS: 'Indent creation failed!',
  INDENT_UPDATION_FAILS: 'Indent updation failed!',
  EXPORT_FAILS: 'Export failed. Please try after some time',
  ERR_NO_RECORD_FOUND: 'Empty Record has uploaded',
  ERR_INVALID_FILE_EXTENSION: 'Invalid file extension. Use .xls or .xlsx format',
  ERR_FILE_TOO_LARGE: 'Upload Size Limit Exceeded 8mb, Please Compress the file and Upload again..!',
  EXISTS_PICKUP: 'Pickup already added',
  ERR_FREIGHT_UPDATE: 'Invoice generated for this Indent',
  ERR_INVALID_ORDER_TYPE: 'Freight updation not applicable for this Indent',
  ERR_INVALID_REQUEST_DATA: '',
  ERR_DUPLICATE_REFERENCE_ID: 'Already Exists',
  ERR_CONFIG_MISSING: 'The feature has been disabled',
  ERR_SYSTEM_USER: 'System role user cannot be updated',
  INDENT_HAS_NO_GATE: 'Select the Gate',
  UPDATE_FAILURE: 'Changes have not been updated!',
  COMMENT_ADD_FAILURE: 'Unable to add comment.',
  INCREMENT_BLOCKING: 'Cannot increment the value',
  DECREMENT_BLOCKING: 'Cannot decrement the value',
  UPDATE_NO_CHANGES: 'No Changes have been made by the user!',
  INVOICE_CREATION_FAILURE: 'Invoice creation failed',
  STATUS_UPDATE_FAILURE: 'Update failed',
  FILTER_NOT_APPLICABLE: 'Current filters are not applicable',
  DATE_FILTER_ERROR: 'Report available only for a single date',
  NO_REPORT_SELECTED: 'Please select any report',
  UPLOAD_LIMIT_EXCEED: 'Upload Limit Exceeded',
  FILE_SIZE_EXCEED: 'Size can not exceed 12MB!',
  INVALID_FORMAT: 'Invalid file format',
  UPLOAD_FAILS: 'Upload failed!',
  CASES_EXCEED: 'Number of Cases cannot exceed the total quantity',
  DELETE_FILE_FAILS: 'Remove file failed!',
  PIECES_EXCEED: 'Number of Pieces cannot exceed the total quantity',
  SHORTAGE_DAMAGE_EXCEED: 'Shortage and Damage count cannot exceed the total quantity',
  TONS_EXCEED: 'Number of Tons cannot exceed the total weight',
  ARRIVAL_CUTOFF_ERROR: 'Arrival cutoff should be greater than Indent cutoff',
  AUTO_CANCEL_CUTOFF_ERROR: 'Auto cancel cutoff should be greater than Indent cutoff',
  GRN_SUBMIT_FAILED: 'GRN approval failed',
  GRN_SAVE_FAILED: 'GRN save failed',
  RETRIGGER_EPOD_FAILED: 'Re-Trigger EPOD failed',
  HOURS_ERROR: 'Hours should be between 0 and 24',
  MINUTES_ERROR: 'Minutes should be between 0 and 59',
  BID_SLOT_MIN_ERROR: 'Bid slot time should be atleast 30 minutes',
  OPTIMA_ABORT_SOME_INVALID_MATERIALS: 'Optima run aborted as some materials are invalid',
  OPTIMA_FOR_PTL_COULD_HAVE_RUN: 'Optima for PTL enabled, PTL indents expected',
  OPTIMA_JOB_NOT_CREATED: 'Optima is not able to process all the deliveries. Please check rejections',
  OPTIMA_JOB_NOT_CREATED_CHECK_REJECTIONS: 'Optima is not able to process all the deliveries. Please check rejections',
  FACTOR_VALUE_EXCEED: 'Factor value must be between 0 and 1',
  BLACKLIST_DRIVER_FAILURE: 'Cannot fetch driver blacklist status',
  BLACKLIST_VEHICLE_FAILURE: 'Cannot fetch vehicle blacklist status',
  THRESHOLD_VALUE_EXCEED: 'Threshold value must be greater than 0',
  DASHBOARD_NOT_DEFINED: 'Dashboard not Available',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  LIST_NOT_AVAILABLE: 'List not available',
  NO_COMMENT_ENTERED: 'No comment entered!',
  DEBIT_ADJUSTMENT_INVALID: 'Adjustment amount cannot be higher than \'Total debited amount\'',
  DEBIT_ADJUSTMENT_NEGATIVE: 'Adjustment amount cannot be negative',
  DEBIT_ADJUSTMENT_FAILED: 'Updating debit adjustment failed',
  OTP_FAILED: 'OTP Number Incorrect',
  EXIM_LISTING_LEG_FAILS: 'Problems in legs data loads problems',
  EXIM_CONTAINER_TYPE_SEARCH_FAILS: 'Problems in container type search loads',
  EXIM_PORT_SEARCH_FAILS: 'Problems in port search loads',
  LOAD_MAP_FAILED: 'Unable to load Map',
  STOP_FAILED: 'Stop failed',
  DUPLICATE_TAGS_CANNOT_BE_UPDATED: 'Duplicate tags cannot be updated',
  DEPOT_FILTER_ERROR: 'Need atleast one depot selection',
  LR_REJECT_FAILS: 'LR Rejections Failed',
  INVALID_INDENT_ID: 'Invalid Indent Id',
  EXCESS_MATERIAL_FAILED: 'Excess Material creation failed : #firstArgument#',
  REMOVE_MATERIAL_EXCESS_ATTACHMENT: 'Remove Material Excess Attachment failed : #firstArgument#',
  PROFORMA_INVOICE_CREATE_FAILS: 'Invoice Creation failed due to duplicate proforma Invoice Number, please try again!',
  BULK_APPROVAL_NO_PERMISSION: 'You do not have permission to perform bulk approval',
  BULK_APPROVAL_SAME_STATUS_REQUIRED: 'Select invoices with the same status to perform bulk approval',
  BULK_APPROVAL_NO_COMMON_NEXT_STATUS: 'Selected invoices do not share a common next approval step',
  BULK_APPROVAL_NO_NEXT_STATUS: 'No next step available for current status',
  BULK_APPROVAL_NO_FEATURE: 'No approval feature enabled',
  BULK_APPROVAL_FAILED: 'Bulk status update failed',
};

export default errorConstants;
